import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapActions, mapState } from "pinia";

import { MessageService } from "../../../services/message-service";
import eventBus from "../../../utilities/eventBus";
import { useUserStore } from "../store/useUsersStore";
import { useCallStore } from "../store/useCallStore";
import { useConversationStore } from "../store/useConversationStore";
import { useMessagesStore } from "../store/useMessagesStore";
import { AnalyticsService } from "../../../services/analytics.service";

import MessagesRenderer from "./components/MessagesRenderer/MessagesRenderer.vue";
import ConversationHeader from "./components/ConversationHeader/ConversationHeader.vue";
import ChatSummerEditor from "../../../resources-vue/vue-custom-elements/MessagingService/ChatSummerEditor/ChatSummerEditor.vue";

export default defineComponent({
    components: {
        ConversationHeader,
        MessagesRenderer,
        ChatSummerEditor
    },
    data() {
        return {
            _messageService: null as MessageService,
            _analyticsService: null as AnalyticsService,
            pageLength: 25,
            showMessageLoader: false,
            showRepliedMsgLoader: false as boolean
        };
    },
    async created() {
        this._messageService = Container.instance.get(MessageService);
        this._analyticsService = Container.instance.get(AnalyticsService);

        eventBus.on("dialogOpened", (value: boolean) => {
            if (!value) {
                this.fetchNewerMessages(this.activeConversationId);
            }
        });

        // eventBus.on("retrySuccessful", () => {
        //     this.readAllPreviousMessages();
        //     this.markConversationAsRead(this.activeConversation.id);
        //     eventBus.emit("messageSent", true);
        // });

        // eventBus.on("navigateToRepliedMsg", this.handleNavigateToRepliedMsg);
        // eventBus.on("convWrapperLoader", (value: boolean) => {
        //     this.showRepliedMsgLoader = value;
        // });
    },
    async mounted() {
        if (this.activeConversationId) await this.fetchMessages(this.activeConversationId, this.pageLength);
    },

    computed: {
        ...mapState(useCallStore, ["currentCallDetails", "showCallHeader"]),

        ...mapState(useConversationStore, {
            activeConversation: "getActiveConversation",
            activeConversationId: "activeConversationId"
        }),

        isCallOngoing() {
            return this.showCallHeader.show && this.showCallHeader.convId === this.activeConversation?.id;
        }
    },

    methods: {
        ...mapActions(useCallStore, ["setCurrentCallDetails", "setShowCallHeader"]),
        ...mapActions(useUserStore, ["upsertUsers"]),
        ...mapActions(useMessagesStore, ["fetchMessages", "fetchNewerMessages"])

        // markMessageError(createdDateTime: Date, messageErrorType: MessageErrorEnum) {
        //     let messages = this.messages.slice(0);
        //     messages.forEach((message: IMessageItem) => {
        //         if (message.isLoading && message.createdOn == createdDateTime) {
        //             message.isLoading = false;
        //             message.isError = true;
        //             message.errorMessage = messageErrorType;
        //         }
        //     });
        //     this.messages = messages;
        // },

        // async handleNavigateToRepliedMsg(id: string) {
        //     while (true) {
        //         const msgs = this.messageCache[this.activeConversation.id].messages;
        //         const found = msgs.find((msg) => msg.id === id);
        //         if (found) {
        //             this.showRepliedMsgLoader = false;
        //             const element = document.getElementById(`msg-id-${id}`);
        //             const innerElement = element?.querySelector(".highlight-body");
        //             element.scrollIntoView({ behavior: "smooth", block: "center" });
        //             innerElement.classList.add("message-highlight");
        //             setTimeout(() => {
        //                 innerElement.classList.remove("message-highlight");
        //             }, 5000);
        //             break;
        //         } else {
        //             if (!this.messageCache[this.activeConversation.id].isAtEnd) {
        //                 this.showRepliedMsgLoader = true;
        //                 await this.fetchMessages(this.pageLength);
        //             } else {
        //                 this.showRepliedMsgLoader = false;
        //                 this._toastrService.error({
        //                     title: `Error`,
        //                     message: "Message not found."
        //                 });
        //                 break;
        //             }
        //         }
        //     }
        // },
    },

    beforeUnmount() {
        // eventBus.off("navigateToRepliedMsg");
        // eventBus.off("convWrapperLoader");
    }
});
